import {LOCALE_ID, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {TransitionComponent} from './transition/transition.component';
import {HttpClientModule} from '@angular/common/http';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {LeadFormComponent} from './transition/lead-form/lead-form.component';
import {CustomerComponent} from './transition/customer/customer.component';
import {CommonModule} from '@angular/common';
import {MatRadioModule} from '@angular/material/radio';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSelectModule} from '@angular/material/select';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatExpansionModule} from '@angular/material/expansion';
import {MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatRippleModule} from '@angular/material/core';
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule} from '@angular/material-moment-adapter';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {ClearableDatePickerComponent} from './clearable-date-picker/clearable-date-picker.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app-routing.module';
import {AgentNamePipe} from './pipe/agent-name.pipe';
import {ObjectComponent} from './transition/object/object.component';
import {DocumentHintDialogComponent, DocumentsComponent} from './transition/documents/documents.component';
import {ToastrModule} from 'ngx-toastr';

const DATE_PICKER_FORMATS = {
  parse: {
    dateInput: ['DD.MM.YYYY']
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@NgModule({
  declarations: [
    AppComponent,
    TransitionComponent,
    CustomerComponent,
    LeadFormComponent,
    ClearableDatePickerComponent,
    AgentNamePipe,
    ObjectComponent,
    DocumentsComponent,
    DocumentHintDialogComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatRadioModule,
    MatButtonModule,
    MatProgressBarModule,
    MatRippleModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatSelectModule,
    HttpClientModule,
    MatMenuModule,
    MatIconModule,
    MatToolbarModule,
    MatExpansionModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ToastrModule.forRoot(
      {
        maxOpened: 5,
        preventDuplicates: true,
        countDuplicates: true,
        timeOut: 5000,
        extendedTimeOut: 8000,
        progressBar: true,
        messageClass: 'mat-typography'
      }
    ),
  ],
  providers: [
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'de-DE'
    }, {
      provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS,
      useValue: {useUtc: true}
    },
    {
      provide: LOCALE_ID,
      useValue: 'de-DE'
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: DATE_PICKER_FORMATS
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
